import React from 'react';
import type { SupabaseClient } from '@supabase/supabase-js';
import { getSupabaseClient } from '../data/supabase';
import { fetchOrderStageGroups } from '../data/orderStageGroups';
import type { OrderStageGroupsResult } from '../data/orderStageGroups';

export function useOrderStageGroups(supabase?: SupabaseClient) {
  const client = supabase ?? getSupabaseClient();
  const [result, setResult] = React.useState<OrderStageGroupsResult>({
    groups: [],
    standaloneStatuses: [],
    groupKeyToStatuses: {},
  });
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const { data, error: fetchError } = await fetchOrderStageGroups({ supabase: client });
        if (!active) return;
        if (fetchError) throw fetchError;
        setResult(data);
      } catch (err) {
        if (active) {
          setError(err instanceof Error ? err.message : 'Failed to load stage groups');
          setResult({ groups: [], standaloneStatuses: [], groupKeyToStatuses: {} });
        }
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [client]);

  return { ...result, loading, error };
}
